import PropTypes from "prop-types";
import React, { useCallback, useMemo, useState } from "react";
import ContextualDropDown from "@/react/components/contextual-drop-down/ContextualDropDown";
import styled from "styled-components";
import { usePopper } from "@/react/components/poppers";

const ButtonDropdownWrapper = styled.div`
  align-self: center;
  cursor: pointer;
  position: relative;
`;

const ButtonDropdown = ({
  children,
  target,
  isOpen,
  setIsOpen,
  dropdownKey,
}) => {
  const [contentEl, setContentEl] = useState(null);
  const { closeAll } = usePopper(dropdownKey);

  const onClose = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const onClickOutside = useCallback(
    (e) => {
      // Needed for preventing the dropdown from closing when selecting options, otherwise menu is closed
      const isSelectOption = e.target?.dataset?.id?.includes("_OPTION_WRAPPER");
      if (contentEl.contains(e.target) || isSelectOption) {
        return;
      }
      onClose();
      closeAll();
    },
    [contentEl, children, onClose]
  );

  const targetElement = useMemo(
    () =>
      ({ ref, onClick }) =>
        (
          <ButtonDropdownWrapper ref={ref} onClick={onClick}>
            {target}
          </ButtonDropdownWrapper>
        ),
    [target]
  );

  return (
    <ContextualDropDown
      isOpen={isOpen}
      onClose={onClose}
      renderTargetElement={targetElement}
      onClickOutside={onClickOutside}
      dropdownKey={dropdownKey}
    >
      <div ref={setContentEl}>{children}</div>
    </ContextualDropDown>
  );
};

ButtonDropdown.propTypes = {
  children: PropTypes.node.isRequired,
  target: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  dropdownKey: PropTypes.string.isRequired,
};
export default ButtonDropdown;
